// components/EmptyState.jsx
// IMP-04 — one reusable empty state so lists stop showing bare "no data" text.
// Renders a centered icon + title + hint, with an optional primary action.
//
//   <EmptyState icon={Inbox} title="No incidents yet"
//     hint="Reported incidents will show up here."
//     actionLabel="Report incident" onAction={() => setShowForm(true)} />
import React from "react";

export function EmptyState({
  icon: Icon,
  title = "Nothing here yet",
  hint = "",
  actionLabel,
  onAction,
  className = "",
  testId = "empty-state",
}) {
  return (
    <div
      className={`flex flex-col items-center justify-center text-center px-6 py-12 ${className}`}
      data-testid={testId}
    >
      {Icon && (
        <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-4" style={{ background: "rgba(3,40,102,0.06)" }}>
          <Icon className="w-7 h-7" style={{ color: "#032866" }} strokeWidth={1.75} />
        </div>
      )}
      <h3 className="text-sm font-bold" style={{ color: "#032866" }} data-testid={`${testId}-title`}>{title}</h3>
      {hint && <p className="text-xs text-slate-400 mt-1.5 max-w-xs">{hint}</p>}
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          className="mt-5 inline-flex items-center gap-1.5 rounded-xl px-4 h-9 text-xs font-semibold text-white shadow-sm transition-transform hover:scale-[1.02] active:scale-95"
          style={{ background: "#032866" }}
          data-testid={`${testId}-action`}
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}

export default EmptyState;
